<template>
    <div class="sim_graf_chart sim_graf_chart-heat">
        <highcharts v-if="heatDaysChartOptions !== null" :options="heatDaysChartOptions"></highcharts>
        <div class="recharts_legend">
            <div class="recharts_legend_item">
                <div class="recharts_legend_item_line">
                </div>
                <span class="recharts_legend_item_text">Граничний рівень ({{ heatLineValue }} днів)</span>
            </div>
            <div class="recharts_legend_item">
                <div class="recharts_legend_item_square" style="background-color: rgb(171, 92, 13);"></div>
                <span class="recharts_legend_item_text">Спека</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HeatDaysChartComponent",
    props: {
        historicalData: null,
        limitsData: null,
    },

    mounted() {
        window.heatLineValue = this.heatLineValue;
        window.getTotalHeatByYear = this.getTotalHeatByYear;
        this.heatDaysChartOptions = {
            chart: {
                type: 'column',
                events: {
                    load: function() {
                        var chart = this;

                        var series = this.series[0];

                        var points = series.processedYData
                        var newSeriesData = [[], [], []]
                        var newSeries = []

                        var dividePoint = (arr, value) => {
                            arr[0].push(value <= window.heatLineValue ? value : window.heatLineValue)
                            arr[1].push(value > window.heatLineValue ? value - window.heatLineValue : 0)
                            arr[2].push(window.heatLineValue)
                        }
                        chart.options.colors = ['#AB5C0D', '#EC8500']

                        series.remove()

                        points.forEach(function(elem) {
                            dividePoint(newSeriesData, elem)
                        });

                        newSeriesData.reverse()
                        newSeriesData.forEach((series, i) => {
                            newSeries.push({
                                data: series,
                                linkedTo: i > 0 ? ':previous' : undefined,
                            })
                        })

                        chart.update({
                            series: newSeries,
                        }, true, true)

                    }
                },
                backgroundColor: '#f8f9fa'
            },
            title: {
                text: '',
            },
            legend:{
                enabled:false
            },
            tooltip: {
                formatter: function() {
                    return false;
                }
            },
            plotOptions: {
                series: {
                    dataLabels: {
                        enabled: true,
                        borderWidth: 0,
                        borderColor: '#ffffff',
                        style: {
                            textOutline: "0px",
                            color: '#000000',
                        },
                        formatter: function () {
                            if(this.color === '#EC8500') {
                                return window.getTotalHeatByYear(this.x);
                            }
                        }
                    },
                    borderWidth: 0,
                    enableMouseTracking: false,
                    stacking: 'normal',
                    pointWidth: 36,
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                }
            },
            xAxis: {
                gridLineWidth: 1.5,
                gridLineColor: '#d7d7d7',
                gridLineDashStyle: 'LongDash',
                categories: this.chartYears,
                formatter: function () {

                }
            },
            yAxis: [
                {
                    gridLineWidth: 1.5,
                    gridLineColor: '#d7d7d7',
                    gridLineDashStyle: 'LongDash',
                    title: {
                        text: ''
                    }
                }
            ],
            series: [
                {
                    width: 36,
                    color: '#EC8500',
                    data: this.heatDaysCount,

                },
                {
                    dashStyle: 'LongDash',
                    marker: {
                        enabled: false
                    },
                    type: 'spline',
                    name: '',
                    color: '#EC8503',
                    width: 1.5,
                    data: this.heatLine,
                    zIndex: 10,
                },
            ]
        };
    },

    data: function () {
        return {
            heatDaysChartOptions: null,
        };
    },

    computed: {
        heatLineValue() {
            return this.limitsData.HD.value;
        },

        heatLine() {
            let heatLineArray = [];
            for (let chartYear of this.chartYears) {
                heatLineArray.push(this.limitsData.HD.value);
            }

            return heatLineArray;
        },

        heatDaysCount() {
            let heatDaysCount = [];

            for (let chartYear of this.chartYears) {
                let countOfHeatDayPerYear = 0;
                for(let dataItem of this.historicalData[chartYear].data) {
                    if(dataItem.heat >= this.limitsData.HD.threshold) {
                        countOfHeatDayPerYear++;
                    }
                }
                heatDaysCount.push(countOfHeatDayPerYear);
            }
            return heatDaysCount;
        },



        chartYears() {
            return Object.keys(this.historicalData);
        },
    },

    methods: {
        getTotalHeatByYear(year) {
            let index = this.chartYears.indexOf(year);
            return Number(this.heatDaysCount[index]).toFixed(0);
        }
    }
}
</script>

<style scoped>

</style>
